<template>
    <div class="wl-container" v-loading="loading">
        <!--线上课程-->
        <div v-if="courseInfo.form === 'ONLINE'">
            <div class="course-header">
                <div class="course-header-title">{{ courseInfo.title }}</div>
                <el-button v-if="!isKpmgUser" icon="el-icon-star-off" class="wl-green-small" @click="goToMyCourse">{{
                    $t('kee_my')
                }}</el-button>
            </div>
            <div class="course-video">
                <div class="video-content">
                    <div v-if="!isKpmgUser" id="player"></div>
                    <img v-else :src="courseInfo.coverImgUrl" alt="" style="width: 100%; height: 100%" />
                </div>
                <div class="course-content">
                    <div class="course-header-title">{{ courseInfo.title }}</div>
                    <div class="course-content-detail">{{ courseInfo.remark }}</div>
                    <div class="course-time">
                        {{ $t('kee_duration') }}: <span style="font-weight: bold">{{ durationTrans(courseInfo.sumDurationFormat) }}</span>
                        <div class="course-collect" @click.stop="collectClick(courseInfo)" v-show="getUser.userType == '2'">
                            <img src="@/assets/img/icon-collect.svg" v-if="courseInfo.collectFlag" class="collect-icon" width="100%" />
                            <img src="@/assets/img/icon-uncollect.svg" v-else class="collect-icon" width="100%" />
                            <span>{{ $t('kee_like') }}</span>
                        </div>
                    </div>
                    <div style="font-size: 12px">{{ $t('kee_viewed', { num: courseInfo.viewNum }) }}</div>
                </div>
            </div>
            <div class="course-item">
                <div class="course-item-header course-header-title">
                    <div>{{ $t('kee_course_column') }}</div>
                    <div class="course-item-label" v-if="!isKpmgUser">
                        <div class="time-val">{{ $t('kee_duration_2') }}</div>
                        <!-- <div class="time-val">{{ $t('kee_completeness') }}</div> -->
                        <div class="play-icon">{{ $t('kee_play') }}</div>
                    </div>
                </div>
                <div class="course-item-content">
                    <div
                        v-for="(item, key) in courseInfo.volumes"
                        :key="key"
                        class="course-list"
                        @click.stop.prevent="watchVideo(item.videoId, true)"
                    >
                        <div class="course-item-child" :class="item.viewingCompletion == 1 ? 'isWatched' : ''" @click="openDetail(item)">
                            <div class="course-play-slider" :style="{ width: item.viewingCompletion < 1 ? '100%' : '0' }"></div>
                            <div
                                :class="[
                                    'item-title',
                                    item.videoId == currentVideo ? 'item-title-active' : '',
                                    item.showDesc ? 'isActive' : ''
                                ]"
                            >
                                {{ item.title }}
                            </div>
                            <div class="item-time" v-if="!isKpmgUser">
                                <div class="time-val">{{ item.duration }}</div>
                                <!-- <div class="time-val">{{item.viewingCompletion * 100}}%</div> -->
                                <i class="el-icon-video-play play-icon" @click.stop.prevent="watchVideo(item.videoId, true)"></i>
                            </div>
                        </div>
                        <el-collapse-transition>
                            <div v-show="item.showDesc">
                                <div class="course-item-desc">{{ item.remark }}</div>
                            </div>
                        </el-collapse-transition>
                    </div>
                </div>
            </div>
        </div>
        <!--线下课程-->
        <div v-if="courseInfo.form === 'OFFLINE'">
            <div class="course-header">
                <div class="course-header-title">{{ $t('kee_course_desc') }}</div>
                <el-button v-if="!isKpmgUser" icon="el-icon-star-off" class="wl-green-small" @click="goToMyCourse">{{
                    $t('kee_my')
                }}</el-button>
            </div>
            <div class="course-offline-content">
                <div class="course-header-title mb-15">{{ courseInfo.title }}</div>
                <div class="flex justify-between my-20" v-if="false">
                    <div class="border-normal course-container">
                        <div class="course-offline-child" v-html="courseInfo.remark"></div>
                        <div class="course-price" v-if="courseInfo.chargeType === 'CHARGED'">
                            {{ $t('kee_price') }}: <span class="price-value">￥{{ courseInfo.priceDesc }}</span>
                        </div>
                        <div class="course-price" v-if="courseInfo.chargeType === 'CHARGED'">
                            {{ $t('kee_discount') }}:
                            <span class="sales-content"><i class="el-icon-warning"></i>{{ courseInfo.discountDescription }}</span>
                        </div>
                    </div>
                    <div class="border-normal qr-container">
                        <div class="qr-image ">
                        <el-image  :src="'data:image/png;base64,' + courseInfo.signupQrCodeByte" alt />
                        {{ $t('scan_qr_for_register') }}
                        </div>
                    </div>
                </div>
                <div v-if="courseInfo.content" v-html="courseInfo.content"></div>
               
            </div>
        </div>
    </div>
</template>
<script>
import API from '@/api'
import { mapGetters } from 'vuex'
export default {
    name: 'courseDetail',
    components: {},
    data() {
        return {
            vodPlayerJs: 'https://player.polyv.net/script/player.js',
            loading: false,
            isOnline: false,
            courseInfo: {},
            vid: '',
            playsafe: '',
            player: null,
            isAutoplay: false,
            currentVideo: ''
        }
    },
    async mounted() {
        await this.getCourseDetail()
        if (this.isKpmgUser && this.courseInfo.form !== 'OFFLINE') {
            this.$message.warning(this.$t('kee_kp_view_in_mp'))
        }
        const __int = setInterval(() => {
            if (
                document.getElementsByClassName('pv-video-wrap') &&
                document.getElementsByClassName('pv-video-wrap')[0] &&
                document.getElementsByClassName('pv-menu') &&
                document.getElementsByClassName('pv-menu')[0] &&
                document.getElementsByClassName('pv-menu')[0].getElementsByTagName('ul') &&
                document.getElementsByClassName('pv-menu')[0].getElementsByTagName('ul')[0]
            ) {
                clearInterval(__int)
                document.getElementsByClassName('pv-video-wrap')[0].addEventListener('contextmenu', function () {
                    document.getElementsByClassName('pv-menu')[0].getElementsByTagName('ul')[0].style.display = 'none'
                })
            } else {
                 
            }
        }, 500)
    },
    computed: {
        courseId() {
            return this.$route.query.courseId
        },
        ...mapGetters('common', {
            getUser: 'getUser'
        }),
        isKpmgUser() {
            return this.getUser.userType === '1'
        }
    },
    methods: {
        durationTrans(v) {
             
            return [v[0], this.$t('hour'), v[1], this.$t('minute'), v[2], this.$t('second')].join(' ')
        },
        collectClick(item) {
            let param = {
                courseId: item.courseId,
                flag: item.collectFlag ? 0 : 1
            }
            API.insights.updateCollectFlagRecord(param).then((res) => {
                if (res.code === '1') {
                    if (item.collectFlag) {
                        item.collectFlag = 0
                    } else {
                        item.collectFlag = 1
                    }
                } else {
                    this.$message.error(this.$t(res.code))
                }
                this.loading = false
            })
        },
        myCourseClick() {
            let param = {
                courseId: this.courseId,
                flag: 1
            }
            API.insights.updateViewFlagRecord(param).then((res) => {
                if (res.code !== '1') {
                    this.$message.error(this.$t(res.code))
                }
            })
        },
        getCourseDetail() {
            this.loading = true
            let param = {
                courseId: this.courseId
            }
            return API.insights.queryCourseDetail(param).then((res) => {
                if (res.code === '1') {
                    this.courseInfo = res.data
                    if (this.courseInfo.form === 'ONLINE' && this.courseInfo.volumes && !this.isKpmgUser) {
                        this.watchVideo(this.courseInfo.volumes[0].videoId)
                        this.currentVideo = this.courseInfo.volumes[0].videoId
                    }
                    if (res.data.viewFlag === 0) {
                        this.myCourseClick()
                    }
                } else {
                    this.$message.error(this.$t(res.code))
                }
                this.loading = false
            })
        },
        watchVideo(videoId, isAutoplay) {
            if (this.getUser.userType == '1') return
            this.currentVideo = videoId
            if (this.player) {
                this.player.destroy()
            }
            this.vid = videoId
            let param = {
                videoId: videoId
            }
            API.insights.getPlaySafeToken(param).then((res) => {
                if (res.code === '1') {
                    this.playsafe = res.data.token
                    if (isAutoplay) {
                        this.isAutoplay = isAutoplay
                    }
                    this.loadPlayerScript(this.loadPlayer)
                } else {
                    this.$message.error(this.$t(res.code))
                }
            })
        },
        loadPlayer() {
            const polyvPlayer = window.polyvPlayer
            let index = 0
            let nextPlaySafe = ''
            const option = {
                wrap: '#player',
                disposable: true,
                vid: this.vid,
                history_video_duration: 1,
                playsafe: this.playsafe,
                viewerInfo: {
                    viewerId: 'KCC_#' + this.getUser.userId // 观众ID
                },
                showLine: 'off'
            }
            if (this.isAutoplay) {
                option.autoplay = this.isAutoplay
            }

             
            this.player = polyvPlayer(option)
            this.player.on('s2j_onPlayStart', () => {
                //订阅视频开始播放事件
                console.info('视频开始播放')
                this.player.j2s_realPlayStatus((res) => {})
                index = this.courseInfo.volumes.findIndex((item) => item.videoId === option.vid)
                if (this.courseInfo.volumes.length > index + 1) {
                    index++
                }
                let param = { videoId: this.courseInfo.volumes[index].videoId }
                API.insights.getPlaySafeToken(param).then((res) => {
                    if (res.code === '1') {
                        nextPlaySafe = res.data.token
                    }
                })
            })
            this.player.on('s2j_onPlayOver', () => {
                //订阅视频开始播放事件
                option.vid = this.courseInfo.volumes[index].videoId
                option.playsafe = nextPlaySafe
                console.info('视频播放完毕', option)
                option.autoplay = true
                this.player.changeVid(option) // 切换下一个视频
                const currVideoIndex = this.courseInfo.volumes.findIndex((v) => v.videoId == this.currentVideo)
                 
                 
                if (currVideoIndex > -1) {
                    this.currentVideo = this.courseInfo.volumes[currVideoIndex + 1].videoId
                }
                 
            })
        },
        loadPlayerScript(callback) {
            if (!window.polyvPlayer) {
                const myScript = document.createElement('script')
                myScript.setAttribute('src', this.vodPlayerJs)
                myScript.onload = callback
                document.body.appendChild(myScript)
            } else {
                callback()
            }
        },
        goToMyCourse() {
            this.$router.push({ name: 'myCourse' })
        },
        openDetail(val) {
            this.courseInfo.volumes.map((item) => {
                if (item.videoId === val.videoId && item.remark) {
                    if (item.showDesc) {
                        this.$set(item, 'showDesc', false)
                    } else {
                        this.$set(item, 'showDesc', true)
                    }
                } else {
                    this.$set(item, 'showDesc', false)
                }
            })
        }
    }
}
</script>
<style scoped>
.wl-container {
    color: #444;
    height: 100%;
    padding: 15px;
}
.course-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
}
.course-header-title {
    font-size: 16px;
    font-weight: bold;
    color: #333333;
}
.course-container{
    padding: 15px;
    margin-right: 20px;
    flex:1;
}
.course-video {
    padding: 15px;
    border-radius: 8px;
    background-color: white;
    display: flex;
    min-height: 300px;
}
.course-item {
    margin-top: 20px;
    /*padding: 15PX;*/
    border-radius: 8px;
    background-color: white;
    height: calc(100% - 320px - 41px);
}
.course-item-header {
    border-bottom: solid 1px #ebebec;
    padding: 15px;
    line-height: 16px;
    font-size: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.video-content {
    min-height: 270px;
    width: 480px;
    border-radius: 8px;
    border: 1px solid #dcdfe6;
    margin-right: 15px;
    overflow: hidden;
}
.course-content {
    flex: 1;
    font-size: 14px;
}
.course-content-detail {
    margin-top: 15px;
    margin-bottom: 20px;
    line-height: 1.5;
    /* overflow-y: hidden; */
    /* text-overflow: ellipsis; */
    /* display: -webkit-box;
    -webkit-line-clamp:5;
    -webkit-box-orient: vertical; */
}
.course-time {
    margin-bottom: 30px;
    display: flex;
    flex-direction: row;
    align-items: center;
}

.course-collect {
    color: #333333;
    font-size: 14px;
    display: flex;
    cursor: pointer;
    margin-left: 10px;
}
.collect-icon {
    height: 16px;
    width: 16px;
    margin-right: 5px;
    margin-top: 1px;
}

.course-item-content {
    height: calc(100% - 47px);
    padding: 15px;
    overflow: auto;
}
.course-item-child {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #f8faff;
    padding: 10px;
    line-height: 12px;
    border-radius: 8px;
    position: relative;
    overflow: hidden;
}

.isWatched {
    background-color: #e3e4e6;
}

.isWatched .course-play-slider {
    background: none !important;
}
.course-play-slider {
    position: absolute;
    height: 32px;
    left: 0;
    background-color: #3879eb;
    opacity: 0.1;
}

.course-list {
    margin-bottom: 12px;
    cursor: pointer;
}
.course-list:last-child {
    margin-bottom: 0;
}
.item-title {
    padding-left: 10px;
    font-size: 12px;
    color: #333333;
    border-left: 3px solid #3879eb;
}

.item-title-active {
    font-weight: bold;
}

.isActive {
    color: #3879eb;
}
.course-item-label {
    display: flex;
    margin-right: 10px;
}
.item-time {
    color: #3879eb;
    display: flex;
}
.time-val {
    width: 80px;
    text-align: center;
}
.play-icon {
    width: 40px;
    text-align: center;
    z-index: 999;
}
i.play-icon {
    font-size: 16px;
}
.course-item-desc {
    padding-top: 12px;
}
.item-time i {
    cursor: pointer;
}
.course-pic {
    height: 438px;
    width: 100%;
    border-radius: 8px;
    overflow: hidden;
}
.course-offline-content {
    margin-top: 15px;
    padding: 20px;
    border-radius: 8px;
    background-color: white;
}
.course-offline-title {
    font-size: 16px;
    font-weight: bold;
    color: #00338d;
}
.course-offline-child {
    margin-top: 15px;
    font-size: 14px;
    color: #333333;
    line-height: 1.5;
}
.course-price {
    margin: 20px 0;
    line-height: 14px;
}
.price-value {
    font-size: 14px;
    color: #fd349c;
    font-weight: bold;
}
.sales-content {
    color: #00c0ae;
    background-color: rgba(0, 154, 68, 0.1);
    padding: 5px 8px;
    border-radius: 20px;
}
.sales-content i {
    margin-right: 5px;
}
.qr-container{
    padding:15px;
    border:1px solid #1e49e2;
}
.qr-image {
    text-align: center;
    width: 100px;
}
img {
    max-width: 80% !important;
}
</style>
